/**
 * BlissNet live sync — app-wide CustomEvent names (Phase A).
 */

export const BLISSNET_HARD_SYNC_REQUEST = 'blissnet-hard-sync-request';

export type BlissNetHardSyncRequestDetail = {
  reason: string;
};

/** Match UI: MatchNotificationProvider listens (event-only; provider tree unchanged). */
export const BLISSNET_LIVE_MATCH = 'blissnet-live-match';

export type BlissNetLiveMatchDetail = {
  matchId: string;
  otherUserId: string;
  otherUserName: string;
  otherUserPhoto: string;
};

/** Fired when `notifications` rows change for current user. */
export const BLISSNET_NOTIFICATIONS_CHANGED = 'blissnet-notifications-changed';
